import RequiredValidator from "@/validators/RequiredValidator";
import {NumberValidator} from "@/validators/NumberValidator";
import {RangeValidator} from "@/validators/RangeValidator";
import {CompanyType} from "@/helpers/constants";
import {enumToArray} from "@/helpers/functions_asi";

export default class CompanyRules {

	public static readonly nameRules = [
		(new RequiredValidator('company.name')).validationRule(),
	];

	public static readonly typeRules = [
		(new RequiredValidator('company.type')).validationRule(),
		(new RangeValidator('company.type', true, enumToArray(CompanyType).map(c => c.value))).validationRule(),
	];

	public static readonly hourlyRateRules = [
		(new NumberValidator('company.hourlyRate')).validationRule(),
	];

	public static readonly dailyLumpSum = [
		(new NumberValidator('company.dailyLumpSum')).validationRule(),
	]

}
